import { render, staticRenderFns } from "./extensionMenu.vue?vue&type=template&id=094dd01b&scoped=true&"
import script from "./extensionMenu.vue?vue&type=script&lang=js&"
export * from "./extensionMenu.vue?vue&type=script&lang=js&"
import style0 from "./extensionMenu.vue?vue&type=style&index=0&id=094dd01b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094dd01b",
  null
  
)

export default component.exports